/* eslint-disable jsx-a11y/iframe-has-title */
import {
  Modal,
  ModalOverlay,
  ModalContent,
  useDisclosure,
  Button,
} from '@chakra-ui/react'
import React from 'react'
import '../index.css'

function Resume() {
  const OverlayOne = () => (
    <ModalOverlay
      bg='blackAlpha.300'
      backdropFilter='blur(10px) hue-rotate(90deg)'
    />
  )

  const OverlayTwo = () => (
    <ModalOverlay
      bg='none'
      backdropFilter='auto'
      backdropInvert='80%'
      backdropBlur='2px'
    />
  )

  const { isOpen, onOpen, onClose } = useDisclosure()
  const [overlay, setOverlay] = React.useState(<OverlayOne />)

  return (
    <>
      <Button
        ml='4'
        onClick={() => {
          setOverlay(<OverlayTwo />)
          onOpen()
        }}
      >
        {' '}
        ♉ RESUME
        {/* <a
          href='https://docs.google.com/file/d/1ogkgikQX6LXt2yCsg3wWiBuDnxDcFUATNyF1L7j8spo/preview'
          target='blank'
        >
          <IconButton bg='transparent' icon={<FaEye />}></IconButton>
          Resume
        </a> */}
      </Button>
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        className='modal'
        size='6xl'
        bg='transparent'
      >
        {overlay}
        <ModalContent>
          <div className='modal-body'>
            <iframe
              src='https://docs.google.com/file/d/1ogkgikQX6LXt2yCsg3wWiBuDnxDcFUATNyF1L7j8spo/preview'
              width='100%'
              height='100%'
              target='self'
            ></iframe>
          </div>
        </ModalContent>
      </Modal>
    </>
  )
}
export default Resume
